import FormField from 'components/community/common/FormField';
import React from 'react';
import { CHAR_LIMIT_MAP } from '../../CreateAirmeetV2/validations';

export const Organiser = ({
    formData,
    errors,
    newOnBoardingFlow = false,
    pageMode = false,
    onOrgNameFocus = () => {},
    label,
    hideSubLabel = false,
    ...rest
}) => (
    <FormField
        id={'organizer'}
        name={'eventOrganiserName'}
        label={
            label || pageMode
                ? 'Organization Name'
                : 'Who’s organizing this event'
        }
        placeholder={'Organized by'}
        filledValue={formData.eventOrganiserName}
        isError={errors.eventOrganiserName}
        errorMsg={errors.eventOrganiserName}
        maxLength={CHAR_LIMIT_MAP['eventOrganiserName'].max}
        variant={'v2'}
        subLabel={
            hideSubLabel
                ? ''
                : pageMode
                ? ''
                : 'Name the Business or Community organizing the event'
        }
        newOnBoardingFlow={newOnBoardingFlow}
        inputValue={pageMode ? formData?.eventOrganiserName : null}
        value={formData?.eventOrganiserName}
        onFocus={onOrgNameFocus}
        {...rest}
    />
);
